import { FC } from 'react'
import { Icon } from '@chakra-ui/react'
import { uniqueId } from '@/services'

export const Jpg: FC = () => {
  const id = `clip${uniqueId()}`
  return (
    <Icon
      width="70px"
      height="70px"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3171_3525)">
        <path
          d="M43.75 2.1875V19.6875H61.25"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
        />
        <path
          d="M61.25 28.4375V19.6875L43.75 2.1875H8.75V28.4375"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M8.75 59.0625V67.8125H61.25V59.0625"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M20.3438 54.25C19.6875 54.25 19.25 54.25 18.5938 54.0313V51.4063C18.8125 51.4063 19.0313 51.4063 19.25 51.625C19.4688 51.8438 19.6875 51.625 19.9063 51.625C20.5625 51.625 20.7813 51.4063 21 51.1875C21.2188 50.9688 21.4375 50.3125 21.4375 49.4375V37.8438H24.9375V49.2188C24.9375 50.9688 24.5 52.2812 23.8437 53.1562C23.1875 54.0312 21.6563 54.25 20.3438 54.25Z"
          fill="white"
        />
        <path
          d="M36.5313 41.7813C36.5313 43.0938 36.0938 44.1875 35.2188 45.0625C34.3438 45.9375 33.25 46.1563 31.7187 46.1563H30.8438V50.3125H27.5625V37.8438H31.9375C33.4688 37.8438 34.7813 38.2812 35.4375 38.9375C36.0938 39.5937 36.5313 40.4688 36.5313 41.7813ZM30.8438 43.3125H31.5C31.9375 43.3125 32.375 43.0938 32.8125 42.875C33.25 42.6563 33.25 42.2188 33.25 41.7813C33.25 40.9063 32.8125 40.4688 31.9375 40.4688H31.0625V43.3125H30.8438Z"
          fill="white"
        />
        <path
          d="M43.5312 43.0938H49V49.875C47.4687 50.3125 45.9375 50.5312 44.1875 50.5312C42.2188 50.5312 40.6875 49.875 39.8125 48.7812C38.9375 47.6875 38.2812 46.1562 38.2812 43.9688C38.2812 42 38.9375 40.4687 40.0312 39.1562C41.125 37.8437 42.875 37.4062 44.8438 37.4062C45.7188 37.4062 46.375 37.4063 47.0312 37.625C47.6875 37.8438 48.3437 38.0625 48.7812 38.2812L47.6875 40.9063C46.8125 40.4688 45.7187 40.25 44.625 40.25C43.5312 40.25 42.875 40.4687 42.4375 41.125C42 41.7812 41.5625 42.875 41.5625 44.1875C41.5625 45.2813 41.7812 46.1562 42.2187 46.8125C42.6562 47.4687 43.3125 47.6875 44.4062 47.6875C44.8437 47.6875 45.2812 47.6875 45.7187 47.4688V45.5H43.5312V43.0938Z"
          fill="white"
        />
        <path
          d="M67.8125 28.4375H2.1875V59.0625H67.8125V28.4375Z"
          stroke="white"
          strokeWidth="4"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="70px" height="70px" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  )
}
